import date from "./date.filter";
import duration from "./duration.filter";
import likes from "./likes.filter";

export default {
  date,
  duration,
  likes
};
